// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the ApiServices.tst template. 
// !!!! Do not modify this file or change may be lost !!!!
/* eslint-disable */
import BaseApi from './BaseApi';
import TableRequestDTO from '../models/TableRequestDTO';
import TableResponseDTO from '../models/TableResponseDTO';
import APITokenUserDTO from '../models/APITokenUserDTO';
import * as CreateAPITokenUserHandler from '../handlerModels/CreateAPITokenUserHandler';
import * as GetAPITokenUserDetailsHandler from '../handlerModels/GetAPITokenUserDetailsHandler';
import * as DeleteAPITokenUserHandler from '../handlerModels/DeleteAPITokenUserHandler';
import * as SaveAPITokenUserDetailsHandler from '../handlerModels/SaveAPITokenUserDetailsHandler';
import * as RegenerateAPITokenUserSecretHandler from '../handlerModels/RegenerateAPITokenUserSecretHandler';

export class APITokenUsersApiService extends BaseApi {

    // post: api/APITokenUsers/list
    public getAPITokenUsersList(tableRequest: TableRequestDTO): Promise<TableResponseDTO<APITokenUserDTO>> {
        let url = `api/APITokenUsers/list`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, TableResponseDTO<APITokenUserDTO>>(tableRequest, 'post', url, true, false);
    }

    // post: api/APITokenUsers/addAPITokenUser
    public addAPITokenUser(addAPITokenUser: CreateAPITokenUserHandler.Request): Promise<CreateAPITokenUserHandler.Result> {
        let url = `api/APITokenUsers/addAPITokenUser`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, CreateAPITokenUserHandler.Result>(addAPITokenUser, 'post', url, true, false);
    }

    // post: api/APITokenUsers/${encodeURIComponent(apiTokenUserId)}
    public getAPITokenUserDetails(apiTokenUserId: string): Promise<GetAPITokenUserDetailsHandler.Result> {
        let url = `api/APITokenUsers/${encodeURIComponent(apiTokenUserId)}`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, GetAPITokenUserDetailsHandler.Result>(null, 'post', url, true, false);
    }

    // post: api/APITokenUsers/deleteAPITokenUser
    public deleteAPITokenUser(deleteAPITokenUser: DeleteAPITokenUserHandler.Request): Promise<DeleteAPITokenUserHandler.Result> {
        let url = `api/APITokenUsers/deleteAPITokenUser`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, DeleteAPITokenUserHandler.Result>(deleteAPITokenUser, 'post', url, true, false);
    }

    // post: api/APITokenUsers/save
    public saveAPITokenUser(apiTokenUser: SaveAPITokenUserDetailsHandler.Request): Promise<SaveAPITokenUserDetailsHandler.Result> {
        let url = `api/APITokenUsers/save`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, SaveAPITokenUserDetailsHandler.Result>(apiTokenUser, 'post', url, true, false);
    }

    // post: api/APITokenUsers/regenerateAPITokenUserSecret
    public regenerateAPITokenUserSecret(regenerateAPITokenUserSecret: RegenerateAPITokenUserSecretHandler.Request): Promise<RegenerateAPITokenUserSecretHandler.Result> {
        let url = `api/APITokenUsers/regenerateAPITokenUserSecret`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, RegenerateAPITokenUserSecretHandler.Result>(regenerateAPITokenUserSecret, 'post', url, true, false);
    }
}
var service = new APITokenUsersApiService();
export default service;
